"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var listItemStyles = function listItemStyles(_a) {
  var toneValueBase = _a.toneValueBase,
      colorBgPopup = _a.colorBgPopup,
      colorIcon = _a.colorIcon;
  return {
    base: {
      display: 'flex',
      height: '26px',
      alignItems: 'center',
      padding: function padding(_a) {
        var _b = _a.indent,
            indent = _b === void 0 ? 0 : _b;
        return "3px 20px 3px " + (3 + 21 * indent) + "px";
      },
      '&:not($disabled):hover, &:not($disabled)$focused': {
        background: colorBgPopup.hover
      },
      '&:not($unselectable)': {
        cursor: 'pointer'
      },
      position: 'relative'
    },
    iconContainer: {
      // OCTAVIUS-1612 добавлии чтобы пофиксить проблему в Safary
      // в chrome проблема не воспроивзодится и это не покрыто тестами никак
      flexShrink: 0,
      position: 'relative',
      width: 21,
      height: '100%',
      '& svg': {
        display: 'block',
        position: 'absolute',
        left: '3px',
        top: '4px',
        fill: colorIcon.normal
      }
    },
    textContainer: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flexShrink: 0,
      maxWidth: '100%'
    },
    focused: {},
    disabled: {
      '&:not($unselectable)': {
        opacity: toneValueBase
      }
    },
    autoheight: {
      height: 'auto'
    },
    unselectable: {}
  };
};

exports.default = listItemStyles;